import React, { useState, useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { useLoading } from "../../context/loadingContext";
import { IoIosMail } from "react-icons/io";
import { MdOutlinePassword } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { loginUser, forgotPassword } from "../../Functions/API/services/authService";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => {
  const { login } = useContext(AuthContext);
  const { setLoading } = useLoading();
  const [form, setForm] = useState({ email: "", password: "" });
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [feedback, setFeedback] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await loginUser(form.email, form.password);
      login();
      navigate("/");
    } catch (err) {
      alert("Invalid Credentials");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!forgotEmail) return setFeedback("Please enter your email");
    /* setLoading(true); */
    try {
      await forgotPassword(forgotEmail);
      setFeedback(true)
      setTimeout(() => setShowForgot(false), 2000);
    } catch (err) {
      setFeedback(false)
      setTimeout(() => setShowForgot(false), 2000);
    } finally {
      /* setLoading(false); */
      console.log(feedback)
    }
  };

  return (
    <div className="Container">
      <div className="wrapper">
        <div className="form-box">
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <div className="input-box">
              <span className="icon"><IoIosMail /></span>
              <input
                name="email"
                type="text"
                onChange={handleChange}
                required
              />
              <label>Email</label>
            </div>
            <div className="input-box">
              <span className="icon"><MdOutlinePassword /></span>
              <input
                name="password"
                type="password"
                onChange={handleChange}
                required
              />
              <label>Password</label>
            </div>
            <div className="remember-forgot">
              <label>
                <input type="checkbox" /> Remember me
              </label>
              {/*<span
                className="forgot-link"
                onClick={() => setShowForgot(true)}
              >
                Forgot Password?
              </span>*/}
            </div>
            <p>MathTounsi is an application based program. Consider applying <a href="https://docs.google.com/forms/d/e/1FAIpQLSeb-dCrYaa8q_nSKGHuAVUMMcJiAQfxRfRRZCEB6CmEg2DBSw/viewform?usp=dialog">here</a>.</p>
            <button type="submit" className="btn">Login</button>
          </form>
        </div>
      </div>

      {/* Forgot Password Modal */}
      {showForgot && (
        <div className="modal-overlay">
          <div className="modal">
            <span
              className="close-btn"
              onClick={() => setShowForgot(false)}
            >
              <IoMdClose />
            </span>
            <h3>Reset Password</h3>
            {feedback!=null && <p className={feedback?"pos":"neg"}>{feedback===true?"✅ A new password has been sent to your email.":"❌ No account found with that email."}</p>}
            <div className="input-box ForgottenEmail">
              <span className="icon"><IoIosMail /></span>
              <input
                type="email"
                placeholder="Enter your email"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
              />
            </div>
            
            <button className="btn" onClick={handleForgotPassword}>
              Confirm
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
